import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Injectable()
export class PackageService {

  constructor(private http:HttpClient) {}

  public getDocumentPackages(){
    return this.http.get("/api/packages");
  }
}
